// extracted by mini-css-extract-plugin
export default {"pageWrap":"yb-z","fullWidth":"zb-z","heading":"Ab-z","fullBleed":"Bb-z","hidden":"Cb-z"};